import React from 'react';
import { Container } from 'react-bootstrap';
import { useStoreSettings } from '../contexts/StoreSettingsContext';
import 'quill/dist/quill.snow.css';
import '../components/Footer.css';

const PrivacyPolicyPage = () => {
    const { settings } = useStoreSettings();

    return (
        <Container className="py-5">
            <h2 className="mb-4">Privacy and Data Protection Policy</h2>
            {settings.privacy_policy ? (
                <div
                    className="policy-content ql-editor"
                    dangerouslySetInnerHTML={{ __html: settings.privacy_policy }}
                />
            ) : (
                <p className="text-muted">Privacy and data protection policy is not configured yet.</p>
            )}
        </Container>
    );
};

export default PrivacyPolicyPage;
